import { render, staticRenderFns } from "./ProxyDomains.vue?vue&type=template&id=57ae2e29&"
import script from "./ProxyDomains.vue?vue&type=script&lang=js&"
export * from "./ProxyDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports